<template>
    <div class="settings-player">
        <switcher-autoplay ref="autoplay" @ready="onReadAutoplay" @start="onStartAutoplay" />
    </div>
</template>

<script setup lang="ts">
    const emit = defineEmits(['data-loading']);

    const onStartAutoplay = (): void => {
        emit("data-loading", true);
    };
    const onReadAutoplay = (): void  => {
        emit("data-loading", false);
    };
</script>